/**
 * Host/port parsing shared by the native and desktop printer wizards and
 * edit modals. Plain TS — no Vue, no strategy dependencies.
 */

export type TParseHostPortResult =
  | { ok: true; host: string; port: number }
  | { ok: false; error: 'host' | 'port' };

/**
 * Parses a host + port pair, auto-splitting a pasted "host:port" (printer
 * self-test pages print the address in that shape) so the built address
 * never becomes the malformed "host:port:port".
 */
export function parseHostPort(
  rawHost: string,
  rawPort: string
): TParseHostPortResult {
  let host = rawHost.trim();
  let portRaw = rawPort.trim();

  const colonIndex = host.indexOf(':');
  if (colonIndex !== -1) {
    const maybeHost = host.slice(0, colonIndex);
    const maybePort = host.slice(colonIndex + 1);
    if (maybeHost && /^\d+$/.test(maybePort)) {
      host = maybeHost;
      portRaw = maybePort;
    }
  }

  if (!host || host.includes(':') || /\s/.test(host)) {
    return { ok: false, error: 'host' };
  }

  const port = Number(portRaw);
  if (!portRaw || !Number.isInteger(port) || port < 1 || port > 65535) {
    return { ok: false, error: 'port' };
  }

  return { ok: true, host, port };
}
